var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuaranteeStampUnavaliable({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 65,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.763 31.988c.023 7.205-3.28 14.012-8.94 18.419L29.007 62.795 13.193 50.407C7.533 46 4.23 39.193 4.253 31.988V4.328a99.911 99.911 0 0 0 24.377-3.02l.378-.098.377.098a99.911 99.911 0 0 0 24.378 3.02v27.66z",
    fill: "#FF335C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.122 48.107-4.013-4.693-6.03-.657 4.829-8.23c2.448 2.608 5.985 4.512 9.907 4.512l-4.693 9.068z",
    fill: "#FFF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.507 48.107-4.692-9.068c3.876 0 7.413-1.904 9.861-4.466l4.874 9.521-6.03-.68-4.013 4.693z",
    fill: "#FFF",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.815 36.772c-6.257 0-11.336-5.056-11.336-11.313 0-6.257 4.965-11.357 11.336-11.357 6.37 0 11.335 5.1 11.335 11.357s-5.078 11.313-11.335 11.313z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF335C",
    d: "M23.306 24.996h10.868v2.415H23.306z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    opacity: 0.2,
    transform: "translate(.15 3.522)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#979797",
    strokeWidth: 0.5,
    fill: "#000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.43 4.736a.242.242 0 0 1 .484 0v1.51a.242.242 0 1 1-.484 0v-1.51zM12.325 22.348a.242.242 0 0 1-.041-.482l1.504-.133a.242.242 0 0 1 .042.483l-1.505.132zM13.975 13.67a.241.241 0 0 1 .216-.43l1.35.677a.241.241 0 1 1-.216.431l-1.35-.677zM19.935 7.153a.241.241 0 0 1 .41-.254l.794 1.286a.241.241 0 0 1-.41.253l-.794-1.285zM45.06 21.866a.242.242 0 1 1-.042.482l-1.505-.132a.242.242 0 0 1 .041-.483l1.505.133zM43.152 13.24a.241.241 0 0 1 .216.43l-1.35.678a.241.241 0 0 1-.216-.431l1.35-.677zM36.998 6.9a.242.242 0 0 1 .41.253l-.793 1.285a.241.241 0 0 1-.41-.253l.793-1.286z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuaranteeStampUnavaliable);
export default __webpack_public_path__ + "static/media/guaranteeStampUnavaliable.fccb4a698adddbfa8ef07125792e6615.svg";
export { ForwardRef as ReactComponent };